import React from 'react'
import { Check } from 'lucide-react'

export interface Step {
  label: string
  isComplete?: boolean
}

export interface StepProgressProps {
  steps: Step[]
  currentStep: number
  onStepClick?: (index: number) => void
}

export function StepProgress({ steps, currentStep, onStepClick }: StepProgressProps) {
  return (
    <div className="w-full py-4">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const isActive = index === currentStep
          const isComplete = index < currentStep || step.isComplete
          const isClickable = onStepClick && index < currentStep

          return (
            <React.Fragment key={index}>
              {/* Step Circle */}
              <div className="flex flex-col items-center">
                <button
                  onClick={() => isClickable && onStepClick(index)}
                  disabled={!isClickable}
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center font-medium text-sm
                    transition-all duration-200
                    ${isComplete
                      ? 'bg-brand-primary text-white'
                      : isActive
                        ? 'bg-brand-primary text-white ring-4 ring-brand-primary/20'
                        : 'bg-background-secondary text-text-secondary border-2 border-border-light'
                    }
                    ${isClickable ? 'cursor-pointer hover:scale-110' : 'cursor-default'}
                  `}
                >
                  {isComplete ? (
                    <Check className="w-5 h-5" />
                  ) : (
                    <span>{index + 1}</span>
                  )}
                </button>
                <span
                  className={`
                    mt-2 text-xs font-medium text-center max-w-[80px]
                    ${isActive ? 'text-brand-primary' : isComplete ? 'text-text-primary' : 'text-text-secondary'}
                  `}
                >
                  {step.label}
                </span>
              </div>

              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="flex-1 h-0.5 mx-2 mb-6">
                  <div
                    className={`
                      h-full transition-all duration-300
                      ${index < currentStep ? 'bg-brand-primary' : 'bg-border-light'}
                    `}
                  />
                </div>
              )}
            </React.Fragment>
          )
        })}
      </div>
    </div>
  )
}
